"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnitSettings = void 0;
const react_1 = __importStar(require("react"));
const __1 = require("../..");
const forms_1 = require("../../forms");
const UnitSettings_styles_1 = require("./UnitSettings.styles");
const UnitSettings = ({ title, settings, systemItems, selectItems, systemLabel, buttonLabel, toastMessage, toastDuration, buttonOnClick, translationKey, translationEditHandler, titleTranslationKey, }) => {
    var _a;
    const [settingsData, setSettingsData] = (0, react_1.useState)(settings);
    const [showToast, setShowToast] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setSettingsData(settings);
    }, [settings]);
    return (react_1.default.createElement(UnitSettings_styles_1.Wrapper, null,
        react_1.default.createElement(UnitSettings_styles_1.Title, { "$inlineTranslation": !!translationKey }, translationKey ? (react_1.default.createElement(forms_1.EditableTitle, { name: title, editHandler: (isCancelled, value) => translationEditHandler && value && translationEditHandler(isCancelled, value, titleTranslationKey), isEditable: !!translationKey })) : (title)),
        react_1.default.createElement(__1.Pills, { label: systemLabel, items: systemItems, defaultSelection: (_a = settingsData.find((d) => d.key === "UnitSystem")) === null || _a === void 0 ? void 0 : _a.value, onChange: (system) => {
                const tempData = [];
                settingsData.forEach((x) => {
                    var _a;
                    if (x.key === "UnitSystem") {
                        tempData.push(Object.assign(Object.assign({}, x), { value: system }));
                    }
                    else {
                        const settingObj = selectItems.find((s) => s.titleKey === x.key);
                        const valueIndex = system === "IMPERIAL" ? settingObj === null || settingObj === void 0 ? void 0 : settingObj.defaultImperialIndex : settingObj === null || settingObj === void 0 ? void 0 : settingObj.defaultMetricIndex;
                        if (valueIndex || valueIndex === 0) {
                            tempData.push(Object.assign(Object.assign({}, x), { value: (_a = settingObj === null || settingObj === void 0 ? void 0 : settingObj.options[valueIndex].value) !== null && _a !== void 0 ? _a : "" }));
                        }
                    }
                });
                setSettingsData(tempData);
            } }),
        react_1.default.createElement(UnitSettings_styles_1.ControlsWrapper, null, selectItems.map((setting, index) => {
            const settingsItem = settingsData.find((x) => x.key === setting.titleKey);
            return (react_1.default.createElement(UnitSettings_styles_1.InputFieldWrapper, { key: index },
                react_1.default.createElement(forms_1.InputFieldCompact, { label: setting.title, value: settingsItem === null || settingsItem === void 0 ? void 0 : settingsItem.value, type: "select", options: setting.options, onChange: (value) => {
                        const filteredSettingsData = settingsData.filter((x) => x.key !== (settingsItem === null || settingsItem === void 0 ? void 0 : settingsItem.key));
                        const tempData = [...filteredSettingsData, Object.assign(Object.assign({}, settingsItem), { value })];
                        setSettingsData(tempData);
                    } })));
        })),
        react_1.default.createElement(UnitSettings_styles_1.ButtonWrapper, null,
            react_1.default.createElement(__1.Button, { label: buttonLabel, onClick: () => {
                    if (buttonOnClick !== undefined) {
                        buttonOnClick(settingsData);
                    }
                    setShowToast(true);
                } }),
            showToast && (react_1.default.createElement(__1.ElevatedSnackBar, { message: toastMessage, duration: toastDuration, id: "unit-settings-save-toast", onClose: () => setShowToast(false) })))));
};
exports.UnitSettings = UnitSettings;
//# sourceMappingURL=UnitSettings.js.map